// import axios from "axios";
// import { useEffect, useState } from "react";
// import Navbar from "../Navbar";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import Swal from "sweetalert2";
// import Footer from "../Footer";
// import { useNavigate } from "react-router-dom";
// import { useOutlet } from "../../context/OutletContext";
// import { FaRegSquareCheck } from "react-icons/fa6";
// import ManageActions from "./ManageActions";

// const Registeruser = () => {
//   const [token, setToken] = useState('')
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [type, setType] = useState("admin");
//   const [isPasswordVisible, setIsPasswordVisible] = useState(false);
//   const [errordel, setErrordel] = useState("");
//   const [erroredit, setErroredit] = useState("");
//   const [data, setData] = useState([]);
//   const [ErrorUserMsg, setErrorUserMsgMsg] = useState(null);
//   const [messagedel, setMessagedel] = useState(true);
//   const [messageedit, setMessageedit] = useState(true);
//   const [oldusername, setOldUsername] = useState("");
//   const [deleteconfirm, setDeleteConfirm] = useState(false);
//   const [editconfirm, setEditConfirm] = useState(false);
//   const [editsectionmsg, setEditSectionMsg] = useState(false);
//   const [showCancelButton, setShowCancelButton] = useState(false);
//   const [registermsg, setRegisterMsg] = useState("");
//   const [selectedOutlets, setSelectedOutlets] = useState([]);
//   const [selectEnabled, setSelectEnabled] = useState(false);
//   const [showOutlets, setShowOutlets] = useState(true);

//   const [outletManagement, setOutletManagement] = useState({
//     show: false,
//     userId: null,
//     username: "",
//     currentOutlets: [],
//   });

//   let url = process.env.REACT_APP_BASE_URL;
//   let ledgerUrl = process.env.REACT_APP_LEDGER_URL;
//   const navigate = useNavigate();

//   const { outletOptions } = useOutlet();

//   const toggleOutlet = (outlet) => {
//     setSelectedOutlets((prev) =>
//       prev.includes(outlet)
//         ? prev.filter((o) => o !== outlet)
//         : [...prev, outlet]
//     );
//   };

//   useEffect(() => {
//     if (!selectEnabled) {
//       setSelectedOutlets(outletOptions);
//     } else {
//       setSelectedOutlets([]);
//     }
//   }, [selectEnabled, outletOptions]);


//   useEffect(() => {
//     let tokenCheck = localStorage.getItem("token");
//     let typeCheck = localStorage.getItem("type")

//     if (tokenCheck === null && typeCheck !== 'admin') {
//       navigate("/");
//     } else {
//       setToken(tokenCheck);
//       localStorage.setItem('token', tokenCheck);
//     }
//   }, [token, navigate]);

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setMessagedel(false);
//       setErrordel(false);
//       setErrorUserMsgMsg(false);
//       setMessageedit(false);
//       setRegisterMsg(false);
//       setErroredit(false);
//     }, 5000);
//     return () => clearTimeout(timeout);
//   }, [ErrorUserMsg, errordel, erroredit, messageedit, registermsg, messagedel]);

//   const handleUsernameChange = (e) => {
//     setUsername(e.target.value);
//   };

//   const handlePasswordChange = (e) => {
//     setPassword(e.target.value);
//   };

//   const handleTypeChange = (e) => {
//     setType(e.target.value);
//   };

//   const resetForm = () => {
//     setUsername("");
//     setPassword("");
//     setType("admin");
//     setEditConfirm(false);
//     setEditSectionMsg(false);
//     setShowCancelButton(false);
//     setShowOutlets(true);
//   };

//   const fetchUserData = async () => {
//     if (!token) return;

//     try {
//       let userlist = { token: token, username: localStorage.getItem("user") };
//       const response = await axios.post(`${url}/userlists`, userlist);


//       if (response.data && Array.isArray(response.data.users)) {
//         setData(response.data.users);
//       } else if (response.data && Array.isArray(response.data)) {
//         setData(response.data);
//       } else {
//         console.error("Unexpected response format", response.data);
//         setData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setData([]);
//     }
//   };

//   useEffect(() => {
//     fetchUserData();
//   }, [deleteconfirm, registermsg, messageedit, messagedel, token]);

//   const toggleVisibility = (e) => {
//     e.preventDefault();
//     setIsPasswordVisible(!isPasswordVisible);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (editconfirm) {
//       try {
//         const usereditData = {
//           token: "test",
//           username: oldusername,
//           new_username: username,
//           new_password: password,
//           new_type: type,
//           restaurantURL: url,
//           ledgerUrl: ledgerUrl || "",
//         };

//         await axios.post(`${url}/edituser`, usereditData);
//         setMessageedit("User edited successfully!");
//         setSelectedOutlets([]);
//         setSelectEnabled(false);
//         resetForm();
//       } catch (error) {
//         console.log(error);
//       }
//     } else {
//       try {
//         const userData = {
//           username,
//           password,
//           type,
//           restaurantURL: url,
//           ledgerUrl: ledgerUrl || "",
//           outlets: selectedOutlets
//         };

//         await axios.post(`${url}/register`, userData);
//         setRegisterMsg("User Registered Successfully");
//         resetForm();
//         setSelectedOutlets([]);
//         setSelectEnabled(false);
//       } catch (error) {
//         console.log(error);
//       }
//     }
//   };

//   const handleAlert = async (username) => {
//     let postdata = { token: "test", username: username };
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         Swal.fire({
//           title: "Deleted!",
//           text: "User has been deleted.",
//           icon: "success",
//         });
//         setDeleteConfirm(true);
//         try {
//           axios.post(`${url}/deleteuser`, postdata);
//           setMessagedel("User deleted successfully!");
//           setErrordel("");
//         } catch (error) {
//           if (error.response && error.response.data) {
//             setErrordel(error.response.data.message || "Failed to delete user");
//           } else {
//             setErrordel("An error occurred while deleting the user.");
//           }
//         }
//       }
//     });
//   };

//   const handleEditAlert = async (username, password, type) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You want to edit user!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, edit user!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         setEditConfirm(true);
//         setEditSectionMsg(true);
//         setShowCancelButton(true);
//         setUsername(username);
//         setPassword(password);
//         setType(type);
//         setOldUsername(username);
//         setShowOutlets(false);
//       }
//     });
//   };

//   const handleManageOutlets = (userId, username, outlets) => {
//     setOutletManagement({
//       show: true,
//       userId,
//       username,
//       currentOutlets: outlets || [],
//     });
//   };

//   const handleCloseOutletManagement = () => {
//     setOutletManagement({
//       show: false,
//       userId: null,
//       username: "",
//       currentOutlets: [],
//     });
//   };

//   const handleAddOutlet = async (outlet) => {
//     const result = await Swal.fire({
//       title: "Add Outlet?",
//       text: `Add ${outlet} to ${outletManagement.username}'s outlets?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, add it!",
//       cancelButtonText: "No, cancel!",
//       confirmButtonColor: "#2563EB",
//       cancelButtonColor: "#9CA3AF",
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.post(`${url}/assign-outlet`, {
//           token: token,
//           user_id: outletManagement.userId,
//           outlet: outlet,
//         });
//         setOutletManagement(prev => ({
//           ...prev,
//           currentOutlets: [...prev.currentOutlets, outlet]
//         }));
//         Swal.fire({
//           title: "Added!",
//           text: "Outlet has been added.",
//           icon: "success",
//           confirmButtonColor: "#2563EB"
//         });
//         fetchUserData();
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to add outlet.",
//           icon: "error",
//           confirmButtonColor: "#DC2626"
//         });
//       }
//     }
//   };

//   const handleRemoveOutlet = async (outlet) => {
//     const result = await Swal.fire({
//       title: "Remove Outlet?",
//       text: `Remove ${outlet} from ${outletManagement.username}'s outlets?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, remove it!",
//       cancelButtonText: "No, cancel!",
//       confirmButtonColor: "#DC2626",
//       cancelButtonColor: "#9CA3AF",
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.post(`${url}/remove-outlet`, {
//           token: token,
//           user_id: outletManagement.userId,
//           outlet: outlet,
//         });
//         setOutletManagement(prev => ({
//           ...prev,
//           currentOutlets: prev.currentOutlets.filter(o => o !== outlet)
//         }));
//         Swal.fire({
//           title: "Removed!",
//           text: "Outlet has been removed.",
//           icon: "success",
//           confirmButtonColor: "#2563EB"
//         });
//         fetchUserData();
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to remove outlet.",
//           icon: "error",
//           confirmButtonColor: "#DC2626"
//         });
//       }
//     }
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Navbar />

//       <div className="flex-grow">
//         <div className="container mx-auto p-4">
//           <div className="flex flex-col md:flex-row gap-24">
//             <div className="w-1/3">
//               <form
//                 autoComplete="off"
//                 onSubmit={handleSubmit}
//                 className="bg-white p-6 rounded-lg shadow-md max-w-md"
//               >
//                 <h2 className="text-xl font-semibold mb-4">
//                   {editsectionmsg ? "Edit Existing User" : "Register New User"}
//                 </h2>

//                 <div className="mb-4">
//                   <label className="block text-gray-700 mb-2" htmlFor="username">
//                     Username
//                   </label>
//                   <input
//                     type="text"
//                     id="username"
//                     className="w-full px-3 py-2 border rounded"
//                     autoComplete="new-username"
//                     value={username}
//                     onChange={handleUsernameChange}
//                     required
//                     disabled={editconfirm}
//                   />
//                   {ErrorUserMsg && (
//                     <p className="text-red-500 mt-1">{ErrorUserMsg}</p>
//                   )}
//                 </div>

//                 <div className="mb-4">
//                   <label className="block text-gray-700 mb-2" htmlFor="password">
//                     Password
//                   </label>
//                   <div className="flex items-center">
//                     <input
//                       type={isPasswordVisible ? "text" : "password"}
//                       id="password"
//                       className="w-full px-3 py-2 border rounded"
//                       autoComplete="new-password"
//                       value={password}
//                       onChange={handlePasswordChange}
//                       required
//                     />
//                     <button
//                       type="button"
//                       className="ml-2 p-2"
//                       onClick={toggleVisibility}
//                     >
//                       {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
//                     </button>
//                   </div>
//                 </div>

//                 <div className="mb-4">
//                   <label className="block text-gray-700 mb-2" htmlFor="type">
//                     User Type
//                   </label>
//                   <select
//                     id="type"
//                     className="w-full px-3 py-2 border rounded"
//                     value={type}
//                     onChange={handleTypeChange}
//                   >
//                     <option value="admin">Admin</option>
//                     <option value="agent">Agent</option>
//                     <option value="kitchen">Kitchen</option>
//                   </select>
//                 </div>

//                 {showOutlets &&
//                   <div className="mb-4">
//                     <label className="flex items-center gap-2 mb-2 text-gray-700">
//                       <input
//                         type="checkbox"
//                         checked={selectEnabled}
//                         onChange={(e) => setSelectEnabled(e.target.checked)}
//                       />
//                       Select Outlets?
//                     </label>
//                     {selectEnabled &&
//                       <div className="border rounded p-2 w-full">
//                         {outletOptions.map((outlet, idx) => {
//                           const isSelected = selectedOutlets.includes(outlet);
//                           return (
//                             <div
//                               key={idx}
//                               onClick={() => toggleOutlet(outlet)}
//                               className={`flex items-center cursor-pointer px-2 py-1 rounded 
//                             ${isSelected ? "bg-gray-100" : ""}`}
//                             >
//                               <span className="mr-2">
//                                 {isSelected ? <FaRegSquareCheck className="h-5 w-5 text-green-700" /> : <FaRegSquareCheck className="h-5 w-5 text-gray-500" />}
//                               </span>
//                               <span>{outlet}</span>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     }
//                   </div>
//                 }

//                 <div className="flex items-center">
//                   <button
//                     type="submit"
//                     className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mr-2"
//                   >
//                     {editsectionmsg ? "Update" : "Register"}
//                   </button>

//                   {showCancelButton && (
//                     <button
//                       type="button"
//                       className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
//                       onClick={resetForm}
//                     >
//                       Cancel
//                     </button>
//                   )}
//                 </div>

//                 {registermsg && (
//                   <p className="text-green-500 mt-2">{registermsg}</p>
//                 )}
//               </form>
//             </div>

//             <div className="w-full md:w-2/3">
//               <div className="bg-white p-6 rounded-lg shadow-md">
//                 <h2 className="text-xl font-semibold mb-4">Registered Users</h2>

//                 {errordel && <div className="text-red-500 mb-4">{errordel}</div>}
//                 {messagedel && (
//                   <div className="text-green-500 mb-4">{messagedel}</div>
//                 )}
//                 {erroredit && <div className="text-red-500 mb-4">{erroredit}</div>}
//                 {messageedit && (
//                   <div className="text-green-500 mb-4">{messageedit}</div>
//                 )}

//                 <div className="overflow-x-auto max-h-[350px] overflow-y-auto">
//                   <table className="min-w-full bg-white">
//                     <thead>
//                       <tr>
//                         <th className="py-2 px-4 border-b text-left">Username</th>
//                         <th className="py-2 px-4 border-b text-left">Password</th>
//                         <th className="py-2 px-4 border-b text-left">Type</th>
//                         <th className="py-2 px-4 border-b text-left">Outlet</th>
//                         <th className="py-2 px-4 border-b text-left">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {Array.isArray(data) &&
//                         data.map((item, index) => (
//                           <tr key={index}>
//                             <td className="py-2 px-4 border-b">{item.username}</td>
//                             <td className="py-2 px-4 border-b">{item.password}</td>
//                             <td className="py-2 px-4 border-b">{item.type}</td>
//                             <td className="py-2 px-4 border-b whitespace-pre-line">
//                               {item.outlets?.join("\n")}
//                             </td>
//                             <td className="py-2 px-4 border-b">
//                               <ManageActions
//                                 item={item}
//                                 handleAlert={handleAlert}
//                                 handleEditAlert={handleEditAlert}
//                                 handleManageOutlets={handleManageOutlets}
//                               />
//                             </td>
//                           </tr>
//                         ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {outletManagement.show && (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//               <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//                 <div className="flex justify-between items-center mb-4">
//                   <h2 className="text-lg font-semibold">
//                     Manage Outlets for {outletManagement.username}
//                   </h2>
//                   <button
//                     onClick={handleCloseOutletManagement}
//                     className="text-gray-500 hover:text-gray-700"
//                   >
//                     ✕
//                   </button>
//                 </div>

//                 <div className="mb-4">
//                   <h3 className="font-medium mb-2 text-lg">Current Outlets:</h3>
//                   {outletManagement.currentOutlets.length > 0 ? (
//                     <div className="space-y-2">
//                       {outletManagement.currentOutlets.map((outlet, idx) => (
//                         <div
//                           key={idx}
//                           className="flex items-center justify-between bg-gray-100 p-2 rounded"
//                         >
//                           <span>{outlet}</span>
//                           <button
//                             onClick={() => handleRemoveOutlet(outlet)}
//                             className="text-red-500 hover:text-red-700"
//                           >
//                             Remove
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <p className="text-gray-500">No outlets assigned</p>
//                   )}
//                 </div>

//                 <div>
//                   <h3 className="font-medium mb-2 text-lg">Available Outlets:</h3>
//                   <div className="space-y-2">
//                     {outletOptions
//                       .filter(o => !outletManagement.currentOutlets.includes(o))
//                       .map((outlet, idx) => (
//                         <div
//                           key={idx}
//                           className="flex items-center justify-between p-2 hover:bg-gray-50 rounded cursor-pointer"
//                           onClick={() => handleAddOutlet(outlet)}
//                         >
//                           <span>{outlet}</span>
//                           <button className="text-green-500 hover:text-green-700">
//                             Add
//                           </button>
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Registeruser;





import axios from "axios";
import { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import Footer from "../Footer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiEdit, FiTrash2, FiEye } from "react-icons/fi";
import { Button, Modal, Spinner } from "react-bootstrap";

// import CounterUserManagement from "./CounterUserRegister";
// import FranchiseUserManagement from "./FranchiseUser";
import CustomSelect from './../SelectSearch/CustomSelect';

const USER_TYPE_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "agent", label: "Agent" },
  // { value: "kitchen", label: "Kitchen" },
  // { value: "reservation", label: "Reservation" },
  { value: "inventory", label: "Inventory" },
];

const Registeruser = () => {
  const [token, setToken] = useState('')
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("admin");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [errordel, setErrordel] = useState("");
  const [erroredit, setErroredit] = useState("");
  const [data, setData] = useState([]);
  const [ErrorUserMsg, setErrorUserMsgMsg] = useState(null);
  const [messagedel, setMessagedel] = useState(true);
  const [messageedit, setMessageedit] = useState(true);
  const [oldusername, setOldUsername] = useState("");
  const [deleteconfirm, setDeleteConfirm] = useState(false);
  const [editconfirm, setEditConfirm] = useState(false);
  const [editsectionmsg, setEditSectionMsg] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [registermsg, setRegisterMsg] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [outletsAccess, setOutletsAccess] = useState([]);
  const [accessLoading, setAccessLoading] = useState(false);

  let url = process.env.REACT_APP_BASE_URL;
  let ledgerUrl = process.env.REACT_APP_LEDGER_URL;
  const navigate = useNavigate();

  const tokenCheck = localStorage.getItem("token");
  const typeCheck = localStorage.getItem("type");

  useEffect(() => {
    if (!tokenCheck || typeCheck !== "admin") {
      toast.warn("Only admin is allowed to access this page");

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else {
      setToken(tokenCheck);
    }
  }, [navigate, tokenCheck, typeCheck]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMessagedel(false);
      setErrordel(false);
      setErrorUserMsgMsg(false);
      setMessageedit(false);
      setRegisterMsg(false);
      setErroredit(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, [ErrorUserMsg, errordel, erroredit, messageedit, registermsg, messagedel]);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const resetForm = () => {
    setUsername("");
    setPassword("");
    setType("admin");
    setEditConfirm(false);
    setEditSectionMsg(false);
    setShowCancelButton(false);
  };

  const fetchUserData = async () => {
    if (!token) return;

    try {
      let userlist = { token: token, username: localStorage.getItem("user") };
      const response = await axios.post(`${url}/userlists`, userlist);

      if (response.data && Array.isArray(response.data.users)) {
        setData(response.data.users);
      } else if (response.data && Array.isArray(response.data)) {
        setData(response.data);
      } else {
        console.error("Unexpected response format", response.data);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [deleteconfirm, registermsg, messageedit, messagedel, token]);

  const toggleVisibility = (e) => {
    e.preventDefault();
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (editconfirm) {
      try {
        const usereditData = {
          token: "test",
          username: oldusername,
          new_username: username,
          new_password: password,
          new_type: type,
          restaurantURL: url,
          baseURL: ledgerUrl || "",
        };

        await axios.post(`${url}/edituser`, usereditData);
        setMessageedit("User edited successfully!");
        resetForm();
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const userData = {
          username,
          password,
          type,
          restaurantURL: url,
          baseURL: ledgerUrl || ""
        };

        await axios.post(`${url}/register`, userData);
        setRegisterMsg("User Registered Successfully");
        resetForm();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleAlert = async (username) => {
    let postdata = { token: "test", username: username };
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleted!",
          text: "User has been deleted.",
          icon: "success",
        });
        setDeleteConfirm(true);
        try {
          axios.post(`${url}/deleteuser`, postdata);
          setMessagedel("User deleted successfully!");
          setErrordel("");
        } catch (error) {
          if (error.response && error.response.data) {
            setErrordel(error.response.data.message || "Failed to delete user");
          } else {
            setErrordel("An error occurred while deleting the user.");
          }
        }
      }
    });
  };

  const handleEditAlert = async (username, password, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to edit user!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, edit user!",
    }).then((result) => {
      if (result.isConfirmed) {
        setEditConfirm(true);
        setEditSectionMsg(true);
        setShowCancelButton(true);
        setUsername(username);
        setPassword(password);
        setType(type);
        setOldUsername(username);
      }
    });
  };

  const handleFetchAccess = async (employeeId) => {
    try {
      setAccessLoading(true);

      const res = await axios.post(`${url}/employee_outlets`, {
        token: token,
        employee_id: employeeId,
      });

      setOutletsAccess(res.data.outlets || []);
    } catch (err) {
      console.error(err);
      setOutletsAccess([]);
      toast.error(
        err?.response?.data?.message || err?.response?.data?.error || "Something went wrong"
      );
    } finally {
      setAccessLoading(false);
    }
  };

  const handleToggle = async (outlet) => {
    try {
      const response = await axios.post(`${url}/toggle_employee_outlet`, {
        employee_outlet_id: outlet.employee_outlet_id,
        token: token,
      });

      toast.success(response.data.message || "Access updated successfully");

      setOutletsAccess((prev) =>
        prev.map((item) =>
          item.employee_outlet_id === outlet.employee_outlet_id
            ? { ...item, status: !item.status }
            : item
        )
      );
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong"
      );
    }
  };

  if (!tokenCheck || typeCheck !== "admin") {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <div className="flex-grow">
          <div className="max-w-2xl mx-auto text-gray-600 italic font-semibold p-3 mt-20 bg-gray-100 rounded-md shadow-lg">
            Only admin can access this page
          </div>
        </div>

        <Footer />
      </div>
    )
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex-grow">
        <div className="container mx-auto p-4">
          <div className="flex flex-col md:flex-row gap-24">
            <div className="w-1/3">
              <form
                autoComplete="off"
                onSubmit={handleSubmit}
                className="bg-white p-6 rounded-lg shadow-md max-w-md"
              >
                <h2 className="text-xl font-semibold mb-4">
                  {editsectionmsg ? "Edit Existing User" : "Register New User"}
                </h2>

                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="username">
                    Username
                  </label>
                  <input
                    type="text"
                    id="username"
                    className="w-full px-3 py-2 border rounded"
                    autoComplete="new-username"
                    value={username}
                    onChange={handleUsernameChange}
                    required
                    disabled={editconfirm}
                  />
                  {ErrorUserMsg && (
                    <p className="text-red-500 mt-1">{ErrorUserMsg}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="password">
                    Password
                  </label>
                  <div className="flex items-center">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      id="password"
                      className="w-full px-3 py-2 border rounded"
                      autoComplete="new-password"
                      value={password}
                      onChange={handlePasswordChange}
                      required
                    />
                    <button
                      type="button"
                      className="ml-2 p-2"
                      onClick={toggleVisibility}
                    >
                      {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="type">
                    User Type
                  </label>
                  <CustomSelect
                    options={USER_TYPE_OPTIONS}
                    value={type}
                    onChange={setType}
                    placeholder="Select user type"
                  />
                </div>

                <div className="flex items-center">
                  <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mr-2"
                  >
                    {editsectionmsg ? "Update" : "Register"}
                  </button>

                  {showCancelButton && (
                    <button
                      type="button"
                      className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  )}
                </div>

                {registermsg && (
                  <p className="text-green-500 mt-2">{registermsg}</p>
                )}
              </form>
            </div>

            <div className="w-full md:w-2/3">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-semibold mb-4">Registered Users</h2>

                {errordel && <div className="text-red-500 mb-4">{errordel}</div>}
                {messagedel && (
                  <div className="text-green-500 mb-4">{messagedel}</div>
                )}
                {erroredit && <div className="text-red-500 mb-4">{erroredit}</div>}
                {messageedit && (
                  <div className="text-green-500 mb-4">{messageedit}</div>
                )}

                <div className="overflow-x-auto max-h-[350px] overflow-y-auto tiny-scrollbar">
                  <table className="min-w-full bg-white text-center">
                    <thead>
                      <tr>
                        <th className="py-2 px-4 border-b">Username</th>
                        <th className="py-2 px-4 border-b">Password</th>
                        <th className="py-2 px-4 border-b">Type</th>
                        <th className="py-2 px-4 border-b">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(data) &&
                        data.map((item, index) => (
                          <tr key={index}>
                            <td className="py-2 px-4 border-b">{item.username}</td>
                            <td className="py-2 px-4 border-b">{item.password}</td>
                            <td className="py-2 px-4 border-b">{item.type}</td>
                            <td className="py-2 px-4 border-b">
                              <div className="flex items-center gap-2 justify-center">

                                {/* View Outlets */}
                                <button
                                  className="p-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow transition"
                                  title="View Outlets"
                                  onClick={() => {
                                    handleFetchAccess(item.id);
                                    setShowModal(true);
                                  }}
                                >
                                  <FiEye size={16} />
                                </button>

                                {/* Edit */}
                                <button
                                  className="p-2 rounded-md bg-blue-100 text-blue-700 hover:bg-blue-200 hover:shadow transition"
                                  title="Edit"
                                  onClick={() =>
                                    handleEditAlert(item.username, item.password, item.type)
                                  }
                                >
                                  <FiEdit size={16} />
                                </button>

                                {/* Delete */}
                                <button
                                  className="p-2 rounded-md bg-red-100 text-red-700 hover:bg-red-200 hover:shadow transition"
                                  title="Delete"
                                  onClick={() => handleAlert(item.username)}
                                >
                                  <FiTrash2 size={16} />
                                </button>

                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Outlet Access</Modal.Title>
            </Modal.Header>

            <Modal.Body>

              {accessLoading ? (
                <div className="text-center py-4">
                  <Spinner animation="border" />
                </div>
              ) : outletsAccess.length === 0 ? (
                <p className="text-center text-muted">No outlets found</p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white rounded-xl overflow-hidden shadow-md">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">
                          Outlet Name
                        </th>
                        <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">
                          Access
                        </th>
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-200">
                      {outletsAccess.map((o) => (
                        <tr
                          key={o.employee_outlet_id}
                          className="hover:bg-gray-50 transition"
                        >
                          <td className="px-6 py-4 text-gray-700 font-medium">
                            {o.name}
                          </td>

                          <td className="px-6 py-4 text-center">
                            <button
                              onClick={() => handleToggle(o)}
                              className={`relative inline-flex h-6 w-12 items-center rounded-full transition duration-300 ${o.status ? "bg-green-500" : "bg-red-400"
                                }`}
                            >
                              <span
                                className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition duration-300 ${o.status ? "translate-x-6" : "translate-x-1"
                                  }`}
                              />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <CounterUserManagement url={url} /> */}
          {/* <FranchiseUserManagement url={url} /> */}

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Registeruser;